import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "2f6e29a1-4df7-4c4e-9ffd-1f32fecacb91",
    content: "Answer A",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-1-a.svg` },
  },
  {
    id: "d8a92cd1-b454-49bc-a053-8d7ffee658b5",
    content: "Answer B",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-1-b.svg` },
  },
  {
    id: "55ba917c-4626-4297-82a7-66bd52875627",
    content: "Answer C",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-1-c.svg` },
  },
  {
    id: "c8b1a48c-aaf5-424a-b772-1d633785126c",
    content: "Answer D",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-1-d.svg` },
  },
];

export const task: Task = {
  id: "ee6ddac7-9ff1-4979-8ceb-4d1a78b151ad",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
    imageHeight: 150,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["c8b1a48c-aaf5-424a-b772-1d633785126c"],
};
